import Theme from "constants/Theme";
import styled from "styled-components/macro";
import Typography from "../../atoms/typography";

const AboutUsFeatures = () => {
  const features = [
    {
      title: "Withdraw Money",
      description:
        "Using the DotPay Android Powered POS devices, people can make card and cardless withdrawals from any of our thousands of agents strategically scattered across the local communities in the country.",
    },
    {
      title: "Send money",
      description:
        "People can avoid long bank queues by using DotPay agents instead. Using our system that is integrated with all commercial banks in Nigeria, our agents collect cash and run transfers within seconds.",
    },
    {
      title: "Pay bills",
      description:
        "From cable tv subscription to data, airtime and utility bills, our agents can help you pay your bills securely and quickly.",
    },
    {
      title: "Loan Services",
      description:
        "We offer up to N5Million for personal and business needs without collateral within 24-48hrs. This service is currently only available in select locations but will be rolled out nationwide soon.",
    },
  ];
  return (
    <FeatureStyling>
      <div className="container">
        <div style={{ marginBottom: "40px" }}>
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={4}
            uppercase
            fontType="Galano"
          >
            What we do
          </Typography.Heading>
          <Typography.Heading
            className="landing__heading"
            color="darkBlue"
            capitalize
            weight="medium"
            level={1}
            fontType="Galano Alt"
          >
            Convenient Banking Services
          </Typography.Heading>
        </div>
        <div className="abf-con">
          {features.map(({ title, description }) => (
            <div className="" key={title}>
              <Typography.Heading
                className=""
                fontType="Galano Alt"
                color="black"
                weight="bold"
                capitalize
                level={4}
                style={{ fontSize: Theme.fontSizes.xlarge }}
              >
                {title}
              </Typography.Heading>
              <Typography.Text
                className="text"
                weight="normal"
                color="subHeadingGrey"
                fontType="Galano Alt"
                style={{
                  fontSize: "1.15rem",
                  lineHeight: "26px",
                }}
              >
                {description}
              </Typography.Text>
            </div>
          ))}
        </div>
      </div>
    </FeatureStyling>
  );
};
const FeatureStyling = styled.div`
  .abf-con {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 70px;
    column-gap: 40px;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
`;
export default AboutUsFeatures;
